var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "stand-input-wrapper",
        { "stand-input": _vm.myType !== "switch" && _vm.myType !== "text" }
      ]
    },
    [
      _vm.myType === "input"
        ? _c(
            "div",
            { staticClass: "stand-input-core", staticStyle: {} },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.disabled,
                  type: "text",
                  readonly: _vm.readonly,
                  size: "mini"
                },
                on: { blur: _vm.handleInputChange },
                model: {
                  value: _vm.myData,
                  callback: function($$v) {
                    _vm.myData = $$v
                  },
                  expression: "myData"
                }
              }),
              _vm.unit
                ? _c("div", { staticClass: "unit" }, [_vm._v(_vm._s(_vm.unit))])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.myType === "text"
        ? _c("div", [_vm._v(" " + _vm._s(_vm.myData) + " ")])
        : _vm._e(),
      _vm.myType === "select"
        ? _c(
            "div",
            { staticClass: "stand-select-core" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    "default-first-option": true,
                    placeholder: "",
                    multiple: _vm.multiple,
                    disabled: _vm.disabled,
                    size: "mini"
                  },
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.myData,
                    callback: function($$v) {
                      _vm.myData = $$v
                    },
                    expression: "myData"
                  }
                },
                _vm._l(_vm.selectOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    style: {
                      color:
                        item.markFlag === 1 ? "#67c23a" : "rgb(96, 98, 102)"
                    },
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.myType === "switch"
        ? _c(
            "div",
            { staticClass: "stand-switch-core" },
            [
              _c("el-switch", {
                attrs: { "active-color": "#537DFC" },
                model: {
                  value: _vm.myData,
                  callback: function($$v) {
                    _vm.myData = $$v
                  },
                  expression: "myData"
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }